export default {
  login: '/webServer/user/login',
  userRole: '/webServer/user/userRole',
  pathList: '/webServer/user/authList',
  userPageList: '/webServer/user/userAuthList',
  userList: 'webServer/user/userList',
  pageAuthOperation: '/webServer/user/pageAuthOperation',
  articleList: '/webServer/article/articleListWeb',
  articleInfo: '/webServer/article/articleInfoWeb',
}